/**
 * SKR Wallpaper Marketplace — dark, minimal, gallery-focused
 * Electric violet accent, deep black canvas, glass morphism overlays
 */

const font = {
  url: 'https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600&family=Syne:wght@400..800&family=DM+Mono:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,600&display=swap',
  family: "'Syne', sans-serif",
};

export const theme = {
  colors: {
    background: '252 20% 5%',
    foreground: '240 20% 96%',
    card: '246 38% 8%',
    'card-foreground': '240 20% 96%',
    popover: '246 38% 8%',
    'popover-foreground': '240 20% 96%',
    primary: '262 83% 66%',
    'primary-foreground': '0 0% 100%',
    secondary: '246 28% 14%',
    'secondary-foreground': '240 16% 70%',
    muted: '246 28% 12%',
    'muted-foreground': '246 16% 55%',
    accent: '262 83% 66%',
    'accent-foreground': '0 0% 100%',
    destructive: '0 72% 51%',
    'destructive-foreground': '0 0% 100%',
    border: '246 24% 14%',
    input: '246 24% 14%',
    ring: '262 83% 66%',
    link: '262 83% 66%',
    'link-hover': '262 83% 78%',
    button: '262 83% 58%',
    'button-foreground': '0 0% 100%',
    'button-border': '262 70% 50%',
    'button-hover': '262 83% 66%',
    'button-hover-foreground': '0 0% 100%',
    'button-hover-border': '262 70% 60%',
    'button-ring': '262 83% 66%',
    'chart-1': '262 83% 66%',
    'chart-2': '160 70% 50%',
    'chart-3': '38 90% 58%',
    'chart-4': '200 80% 58%',
    'chart-5': '340 75% 58%',
    'sidebar-background': '246 38% 6%',
    'sidebar-foreground': '240 20% 96%',
    'sidebar-primary': '262 83% 66%',
    'sidebar-primary-foreground': '0 0% 100%',
    'sidebar-accent': '246 28% 14%',
    'sidebar-accent-foreground': '240 16% 70%',
    'sidebar-border': '246 24% 14%',
    'sidebar-ring': '262 83% 66%',
  },
  font,
  radius: '0.75rem',
};
